import { useCallback, useState } from "react";

/**
 * Opens course files in the integrated embed modal (same UX as student campus).
 * @returns {{
 *   embedArchivo: { nombre?: string, storageKey?: string, url?: string } | null,
 *   embedOpen: boolean,
 *   openCourseMaterialEmbed: (archivo: { nombre?: string, storageKey?: string, url?: string }) => boolean,
 *   closeCourseMaterialEmbed: () => void,
 * }}
 */
export function useCourseMaterialEmbed() {
  const [embedArchivo, setEmbedArchivo] = useState(null);

  const openCourseMaterialEmbed = useCallback((archivo) => {
    if (!archivo || typeof archivo !== "object") {
      return false;
    }
    setEmbedArchivo(archivo);
    return true;
  }, []);

  const closeCourseMaterialEmbed = useCallback(() => {
    setEmbedArchivo(null);
  }, []);

  return {
    embedArchivo,
    embedOpen: embedArchivo !== null,
    openCourseMaterialEmbed,
    closeCourseMaterialEmbed,
  };
}
